import {jsx} from 'panel';

import {FilterValueProps} from 'common/query-builder/query-entry-section/row-types/filter/types';
// eslint-disable-next-line import/no-cycle
import {QueryEntrySectionEl} from 'common/query-builder/query-entry-section';
import {
  EntrySectionUpdateEvent,
  QueryFilterEntry,
  RowLabelType,
  SelectorTypeDefinitions,
} from 'common/query-builder/query-entry-section/types';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {PropertyType} from 'common/report/constants';
import {isComputedListPropertyFilter} from 'common/widgets/property-filter-menu/utils';

interface Props {
  params: FilterValueProps;
}

function FilterListObjectValue({params}: Props) {
  const entries: QueryFilterEntry[] = (params.filter.listItemFilters || []).map((entry) => ({
    event: entry,
    type: SelectorTypeDefinitions.Filter,
    filters: [],
  }));

  const emptyPlaceholder: QueryFilterEntry = {
    event: {},
    type: SelectorTypeDefinitions.Filter,
    filters: [],
  };

  const handleUpdate = ({detail: {entries}}: EntrySectionUpdateEvent<QueryFilterEntry>) => {
    let filters = entries.map((entry) => new PropertyFilter(entry.event));

    // when selecting a computed property, we want to replace all other existing filters
    const computedFilter = filters.find((filter) => isComputedListPropertyFilter(filter));
    if (computedFilter) {
      filters = [computedFilter];
    }

    params.updateEntry(params.filter.setAttribute(`listItemFilters`, filters));
  };

  return (
    <div sel='.mp-filter-parts-list-objects'>
      <QueryEntrySectionEl
        attrs={{
          'data-group-id': params.dataGroupId,
          entries,
          'project-id': params.projectId,
          'workspace-id': params.workspaceId,
          'user-id': params.userId,
          'event-names': params.eventNames,
          readonly: params.readonly,
          'row-types': [SelectorTypeDefinitions.Filter],
          'row-draggable': false,
          'row-drop-disabled': true,
          'row-label-type': RowLabelType.None,
          'empty-placeholder': emptyPlaceholder,
          'disable-add-entry': true,
          'disable-map-to-lookup-table': true,
          elref: `listOfObjectsFilterSection`,
        }}
        params={{
          listProperty: params.filter,
          rowActions: params.rowActions,
          disabledTypecastTypes: [PropertyType.List, PropertyType.Object],
        }}
        props={{
          isStagingRow: !entries.length || params.hasPlaceholder || params.isActive,
        }}
        on={{
          update: handleUpdate,
          abortStage: () => params.setActiveEntry(`close`),
        }}
      />
    </div>
  );
}

export const FilterListObjectValueEl = FilterListObjectValue;
